import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/common/header/header";
import "./dashboard.css";

const AdminLayout = () => {
  const { i18n } = useTranslation();
  const [fontSizeClassIndex, setFontSizeClassIndex] = useState(2);
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("theme") === "dark",
  );
  const [isColorless, setIsColorless] = useState(
    () => localStorage.getItem("colorless") === "true",
  );
  const [colorScheme, setColorScheme] = useState(
    () => localStorage.getItem("colorScheme") || "default",
  );

  const fontSizeClasses = [
    "font-size-xs",
    "font-size-sm",
    "font-size-md",
    "font-size-lg",
    "font-size-xl",
  ];

  const theme = darkMode ? "dark" : "light";

  const darkTheme = () => {
    setDarkMode(true);
    localStorage.setItem("theme", "dark");
  };

  const lightTheme = () => {
    setDarkMode(false);
    localStorage.setItem("theme", "light");
  };

  const toggleColorlessMode = () => {
    setIsColorless((prev) => {
      const newValue = !prev;
      localStorage.setItem("colorless", newValue);
      return newValue;
    });
  };

  const handleGoldenTheme = () => {
    setIsColorless(false);
    setColorScheme("golden");
    localStorage.setItem("colorless", "false");
    localStorage.setItem("colorScheme", "golden");
    document.body.classList.remove("colorless-mode");
  };

  const handleGreenTheme = () => {
    setIsColorless(false);
    setColorScheme("green");
    localStorage.setItem("colorless", "false");
    localStorage.setItem("colorScheme", "green");
    document.body.classList.remove("colorless-mode");
  };

  const handlePrimaryTheme = () => {
    setIsColorless(false);
    setColorScheme("default");
    localStorage.setItem("colorless", "false");
    localStorage.setItem("colorScheme", "default");
    document.body.classList.remove("colorless-mode");
  };

  const handleLightBlueTheme = () => {
    setIsColorless(false);
    setColorScheme("lightblue");
    localStorage.setItem("colorless", "false");
    localStorage.setItem("colorScheme", "lightblue");
    document.body.classList.remove("colorless-mode");
  };

  const handleBrownTheme = () => {
    setIsColorless(false);
    setColorScheme("brown");
    localStorage.setItem("colorless", "false");
    localStorage.setItem("colorScheme", "brown");
    document.body.classList.remove("colorless-mode");
  };

  const handleResetSetting = () => {
    setIsColorless(false);
    setDarkMode(false);
    setFontSizeClassIndex(2);
    setColorScheme("default");

    localStorage.setItem("colorless", "false");
    localStorage.setItem("theme", "light");
    localStorage.setItem("colorScheme", "default");

    document.body.classList.remove("colorless-mode");
  };

  const increaseFontSize = () => {
    if (fontSizeClassIndex < fontSizeClasses.length - 1) {
      setFontSizeClassIndex((prevIndex) => prevIndex + 1);
    }
  };

  const resetFontSize = () => {
    setFontSizeClassIndex(2);
  };

  const decreaseFontSize = () => {
    if (fontSizeClassIndex > 0) {
      setFontSizeClassIndex((prevIndex) => prevIndex - 1);
    }
  };

  useEffect(() => {
    const savedLang = localStorage.getItem("selectedLang");
    const initialLang = savedLang ? JSON.parse(savedLang).code : "en";
    i18n.changeLanguage(initialLang);
  }, [i18n]);

  useEffect(() => {
    document.body.classList.remove(
      "golden-theme",
      "green-theme",
      "default-theme",
      "lightblue-theme",
      "brown-theme",
    );
    document.body.classList.add(`${colorScheme}-theme`);
    document.body.classList.remove("colorless-mode");
  }, [colorScheme]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
      document.body.classList.remove("light-mode");
    } else {
      document.body.classList.add("light-mode");
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  useEffect(() => {
    if (isColorless) {
      document.body.classList.add("colorless-mode");
    } else {
      document.body.classList.remove("colorless-mode");
    }
  }, [isColorless]);

  useEffect(() => {
    document.body.classList.remove(...fontSizeClasses);
    document.body.classList.add(fontSizeClasses[fontSizeClassIndex]);
  }, [fontSizeClassIndex]);

  return (
    <>
      <div className="main-content-area printable-content">
        <Header
          increaseFontSize={increaseFontSize}
          resetFontSize={resetFontSize}
          decreaseFontSize={decreaseFontSize}
          theme={theme}
          darkTheme={darkTheme}
          lightTheme={lightTheme}
          colorScheme={colorScheme}
          toggleColorlessMode={toggleColorlessMode}
          handleGoldenTheme={handleGoldenTheme}
          handleGreenTheme={handleGreenTheme}
          handlePrimaryTheme={handlePrimaryTheme}
          handleLightBlueTheme={handleLightBlueTheme}
          handleBrownTheme={handleBrownTheme}
          handleResetSetting={handleResetSetting}
        />
        <div className="main-wrapper dashboard">
          <Outlet />
        </div>
      </div>
    </>
  );
};
export default AdminLayout;
